import { useMemo } from 'react'

import { useAkteContext } from '../../../../hooks/context/useAkteContext'
import type {
  ProcessUebergabeStepType,
} from '@dpa/common/dist/prismaGenerated/inputTypeSchemas/ProcessUebergabeStepSchema'

export function useRelevantHandovers() {
  const akte = useAkteContext()

  const relevantHandovers = useMemo(() => {
    const relevantHandovers = new Set<ProcessUebergabeStepType>()
    const workonStates = akte.stateHistory?.filter(({ state }) => state.startsWith("workOn_")).map(({ state }) => state)

    if (workonStates?.includes("workOn_Vertrieb2PE")) {
      relevantHandovers.add("Vertrieb2PE")
    }
    if (
      workonStates?.includes("workOn_PE2Vertrieb") ||
      akte.stateHistory?.some(({ state }) =>
        [
          'preHandover_PE2Vertrieb',
          'handover_PE2Vertrieb',
          'decision_UmsetzungsplanungBeauftragt',
          'terminated_preUmsetzungsplanung',
        ].includes(state),
      )
    ) {
      relevantHandovers.add("PE2Vertrieb")
    }
    if (workonStates?.includes("workOn_Vertrieb2ENG")) {
      relevantHandovers.add("Vertrieb2ENG")
    }
    if (workonStates?.includes("workOn_ENG2Vertrieb")) {
      relevantHandovers.add("ENG2Vertrieb")
    }
    if (
      workonStates?.includes('workOn_CompletionOfPlanning') ||
      akte.stateHistory?.some(({ state }) =>
        [
          'preHandover_CompletionOfPlanning',
          'handover_CompletionOfPlanning',
          'workOn_CompletionOfPlanning2Vertrieb',
          'handover_CompletionOfPlanning2Vertrieb',
          'decision_UmsetzungBeauftragt',
          'terminated_preUmsetzung',
        ].includes(state),
      )
    ) {
      relevantHandovers.add('CompletionOfPlanning')
    }
    if (workonStates?.includes("workOn_Vertrieb2Projektleitung")) {
      relevantHandovers.add("Vertrieb2Projektleitung")
    }
    if (workonStates?.includes('workOn_Projektleitung2SuW')) {
      relevantHandovers.add('Projektleitung2SuW')
    }

    if (
      akte.stateHistory?.some(({ state }) =>
        [
          'entry_Projektleitung2SuW',
          'decision_preliminaryHandover_Projektleitung2SuW',
          'preHandover_Projektleitung2SuW',
          'handover_Projektleitung2SuW',
        ].includes(state),
      )
    ) {
      relevantHandovers.add('Projektleitung2SuW')
    }

    if (
      workonStates?.includes('workOn_preliminaryHandover_Projektleitung2SuW') ||
      workonStates?.includes('workOn_preliminaryToFinalHandover_Projektleitung2SuW') ||
      akte.stateHistory?.some(({ state }) =>
        [
          'handover_preliminaryHandover_Projektleitung2SuW',
          'handover_preliminaryToFinalHandover_Projektleitung2SuW',
        ].includes(state),
      )
    ) {
      relevantHandovers.add('preliminaryHandover_Projektleitung2SuW')
    }

    if (
      workonStates?.includes('workOn_finalHandover_Projektleitung2SuW') ||
      workonStates?.includes('workOn_directFinalHandover_Projektleitung2SuW') ||
      workonStates?.includes('workOn_preliminaryToFinalHandover_Projektleitung2SuW') ||
      akte.stateHistory?.some(({ state }) =>
        [
          'handover_directFinalHandover_Projektleitung2SuW',
          'handover_preliminaryToFinalHandover_Projektleitung2SuW',
          'handover_terminated_inBetrieb',
          'terminated_inBetrieb',
        ].includes(state),
      )
    ) {
      relevantHandovers.add('finalHandover_Projektleitung2SuW')
    }

    if (
      workonStates?.includes('workOn_Projektleitung2SuW_withoutContract') ||
      workonStates?.includes('workOn_Fremdbetrieb') ||
      akte.stateHistory?.some(({ state }) =>
        [
          'handover_GewaehrleistungsUebergabe',
          'handover_terminated_inFremdbetrieb',
          'terminated_inFremdbetrieb',
        ].includes(state),
      )
    ) {
      relevantHandovers.add('SuW2Running')
    }
    return Array.from(relevantHandovers)
  }, [akte.stateHistory])

  return relevantHandovers
}
